import React, { useEffect, useState } from "react";
import { Button, FormGroup, Glyphicon } from "react-bootstrap";
import * as Api from "../../../../../api/cp/members";
import * as constants from "../constants";
import ParticipantAdditionalInfo from "../ParticipantsModals/ParticipantAdditionalInfo";

import './styles.scss';

const ParticipantsTableRow = (
    {
        participant,
        roles,
        tags,
        checked,
        onEdit,
        onDelete,
        onHideMember,
        onToggleMember,
    }
) => {
    const [participantRoles, setParticipantRoles] = useState([]);
    const [participantTags, setParticipantTags] = useState([]);
    const [isModalVisible, setModalVisible] = useState(false);
    const [isRolesModalType, setRolesModalType] = useState(false);

    useEffect(() => {
        setParticipantRoles(participant[constants.FIELD_ROLES] || []);
    }, [participant[constants.FIELD_ROLES]]);

    useEffect(() => {
        setParticipantTags(participant[constants.FIELD_TAGS] || []);
    }, [participant[constants.FIELD_TAGS]]);

    const handleOpenModal = (type) => {
        setRolesModalType(type === constants.FIELD_ROLES);
        setModalVisible(true);
    };

    const handleAddTag = async (id) => {
        try {
            const response = await Api.createMemberTag(participant[constants.FIELD_ID], id);
            setParticipantTags(response[constants.FIELD_TAGS]);
        } catch (error) {
            console.error(error);
        }
    };

    const handleAddRole = async (id) => {
        try {
            const response = await Api.createMembertRole(participant[constants.FIELD_ID], id);
            setParticipantRoles(response[constants.FIELD_ROLES]);
        } catch (error) {
            console.error(error);
        }
    };

    const handleDeleteTag = async (id) => {
        try {
            const response = await Api.deleteMemberTag(participant[constants.FIELD_ID], id);
            setParticipantTags(response[constants.FIELD_TAGS]);
        } catch (error) {
            console.error(error);
        }
    };

    const handleDeleteRole = async (id) => {
        try {
            const response = await Api.deleteMemberRole(participant[constants.FIELD_ID], id);
            setParticipantRoles(response[constants.FIELD_ROLES]);
        } catch (error) {
            console.error(error);
        }
    };

    const handleUpdateTagsOrder = async (list) => {
        try {
            setParticipantTags(list);
            const payload = list.map(({id}) => id);
            await Api.updateMemberTagsOrder(participant[constants.FIELD_ID], payload);
        } catch (error) {
            console.error(error);
        }
    };

    const handleUpdateRolesOrder = async (list) => {
        try {
            setParticipantRoles(list);
            const payload = list.map(({id}) => id);
            await Api.updateMemberRolesOrder(participant[constants.FIELD_ID], payload);
        } catch (error) {
            console.error(error);
        }
    };

    return (
        <>
            <td>
                <input
                    type="checkbox"
                    checked={checked}
                    onChange={() => onToggleMember(participant.id)}
                />
            </td>
            <td style={{width: '80px'}}>
                {participant[constants.FIELD_ID]}
            </td>
            <td>
                {participant[constants.PARTICIPANT_LASTNAME_RU] || participant[constants.PARTICIPANT_LASTNAME_EN]}
            </td>
            <td>
                {participant[constants.PARTICIPANT_NAME_RU] || participant[constants.PARTICIPANT_NAME_EN]}
            </td>
            <td>
                {participant[constants.PARTICIPANT_PATRONYMIC_RU] || participant[constants.PARTICIPANT_PATRONYMIC_EN]}
            </td>
            <td>
                {participant[constants.PARTICIPANT_COMPANY_RU] || participant[constants.PARTICIPANT_COMPANY_EN]}
            </td>
            <td>
                <FormGroup className="participant-table-row__block">
                    <Button onClick={() => handleOpenModal(constants.PARTICIPANT_ROLES)}>
                        {!!participantRoles.length
                            ? <Glyphicon glyph="pencil" />
                            : 'Добавить'
                        }
                    </Button>
                    {!!participantRoles.length && (
                        <span className="participant-table-row__list">
                            {participantRoles.map((role) => (
                                <span
                                    key={role.id}
                                    className="participant-table-row__list-property"
                                >
                                    {role?.[constants.TITLE_RU] || role?.[constants.TITLE_EN]}
                                </span>
                            ))}
                        </span>
                    )}
                </FormGroup>
            </td>
            <td>
                <FormGroup className="participant-table-row__block">
                    <Button onClick={() => handleOpenModal(constants.PARTICIPANT_TAGS)}>
                        {!!participantTags.length
                            ? <Glyphicon glyph="pencil" />
                            : 'Добавить теги'
                        }
                    </Button>
                    {!!participantTags.length && (
                        <span className="participant-table-row__list">
                            {participantTags.map((tag) => (
                                <span
                                    key={tag.id}
                                    className="
                                        participant-table-row__list-property
                                        participant-table-row__list-property--tag
                                    "
                                    style={{backgroundColor: tag.color}}
                                >
                                    {tag?.[constants.TITLE_RU] || tag?.[constants.TITLE_EN]}
                                </span>
                            ))}
                        </span>
                    )}
                </FormGroup>
            </td>
            <td>
                <Button onClick={() => onEdit(participant)}>
                    <Glyphicon glyph="pencil" />
                </Button>
            </td>
            <td>
                <Button onClick={() => onHideMember({ids: [participant.id], hide: !participant.hide})}>
                    <Glyphicon glyph={participant.hide ? 'eye-close' : 'eye-open'} />
                </Button>
            </td>
            <td>
                <Button onClick={() => onDelete(participant[constants.FIELD_ID])}>
                    <Glyphicon glyph="trash" />
                </Button>
            </td>

            <ParticipantAdditionalInfo
                isModalVisible={isModalVisible}
                title={`${isRolesModalType ? 'Назначить дополнительный признак участнику' : 'Добавить теги'}`}
                isRolesModalType={isRolesModalType}
                list={isRolesModalType ? roles : tags}
                participantList={isRolesModalType ? participantRoles : participantTags}
                onAdd={isRolesModalType ? handleAddRole : handleAddTag}
                onDelete={isRolesModalType ? handleDeleteRole: handleDeleteTag}
                onUpdateOrder={isRolesModalType ? handleUpdateRolesOrder: handleUpdateTagsOrder}
                onClose={() => setModalVisible(false)}
            />
        </>
    );
};

export default ParticipantsTableRow;
